export const SET_LAUNCHPAD_DESTINATIONS = "setDestinations";
export const SET_FETCHING = "setFetching";
